import { useEffect, useRef } from "react"

import {
	checkKemsuWebSystemSessionValidity,
	logout,
	useUserInfo
} from "~/domain/user-session"

/**
 * Компонент, который запускает синхронизацию с сессией системы на KemsuWeb
 * @param props
 * @component
 * @category Component
 */
export function SyncWithKemsuWebSystemSession({
												  syncInterval
											  }: {
	/**
	 * период синхронизации в мс.
	 */
	syncInterval: number
}) {
	const userInfo = useUserInfo()
	const intervalIdRef = useRef(0)

	useEffect(() => {
		if (!userInfo && intervalIdRef.current) {
			console.log(
				"Синхронизация с сессией системы на KemsuWeb завершена."
			)
			clearInterval(intervalIdRef.current)
			intervalIdRef.current = 0
		}

		if (syncInterval > 0 && userInfo && intervalIdRef.current == 0) {
			console.log("Запущена синхронизация с сессией системы на KemsuWeb...")

			const sync = async () => {
				const isSessionValid =
					await checkKemsuWebSystemSessionValidity()

				if (!isSessionValid) {
					await logout()
				}
			}

			intervalIdRef.current = window.setInterval(sync, syncInterval)
		}

		return () => {
			if (intervalIdRef.current) {
				window.clearInterval(intervalIdRef.current)
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [userInfo, syncInterval])

	return null
}
